import React from 'react';
import { ModuleGrid } from '../../../layouts/ModuleGrid';
import { SectionHeader } from '../../SectionHeader';
import UploadCard from '../components/upload-card';
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import TiltMessage from "../../../components/feedback/TiltMessage";


const UploadPage: React.FC = () => {
    const showTiltMessage = useIsPortraitMobile();

    return (
        <>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="Upload" />

                <ModuleGrid>
                    <div className="min-w-[250px] flex-1 col-span-6 lg:col-span-2 flex flex-col h-full">
                        <UploadCard uploadType="sales_order" title="FC Sales Order" />
                    </div>
                    <div className="min-w-[250px] flex-1 col-span-6 lg:col-span-2 flex flex-col h-full">
                        <UploadCard uploadType="sellin" title="FC Sell-in" />
                    </div>
                    <div className="min-w-[250px] flex-1 col-span-6 lg:col-span-2 flex flex-col h-full">
                        <UploadCard uploadType="ats" title="FC ATS" />
                    </div>
                </ModuleGrid>
            </div>
        </>
    );
};

export default UploadPage